(() => {
  const params = new URLSearchParams(window.location.search);
  const ideaCode = (params.get('idea') || '').trim().toUpperCase();
  const ideaMode = params.get('idea_mode') === 'inspiration' ? 'inspiration' : 'exact';

  if (!/^XOA-\d{3}$/.test(ideaCode)) return;

  const modeLabel = ideaMode === 'inspiration' ? 'Inspiraation lähtökohta' : 'Valmis malli sellaisenaan';

  const upsertProperty = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.append(input);
    }
    input.value = value;
  };

  const addSelectionNotice = () => {
    const productInfo = document.querySelector('.product__info-container');
    if (!productInfo || productInfo.querySelector('[data-xoa-selected-idea]')) return;

    const notice = document.createElement('aside');
    notice.className = 'xoa-selected-nail-idea';
    notice.dataset.xoaSelectedIdea = ideaCode;
    notice.setAttribute('aria-label', 'Valittu kynsi-idea');

    const eyebrow = document.createElement('span');
    eyebrow.textContent = 'Ideakirjastosta valittu';
    const heading = document.createElement('strong');
    heading.textContent = ideaCode;
    const description = document.createElement('p');
    description.textContent = `${modeLabel}. Ideakoodi liitetään automaattisesti tilaukseen.`;
    notice.append(eyebrow, heading, description);

    const firstProductForm = productInfo.querySelector('product-form');
    if (firstProductForm) firstProductForm.before(notice);
    else productInfo.append(notice);
  };

  const applyIdea = () => {
    document.querySelectorAll('product-form form[action*="/cart/add"]').forEach((form) => {
      upsertProperty(form, 'properties[Kynsi-idea]', ideaCode);
      upsertProperty(form, 'properties[Idean käyttötapa]', modeLabel);
    });
    addSelectionNotice();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyIdea, { once: true });
  else applyIdea();

  document.addEventListener('shopify:section:load', applyIdea);
})();
